/**
 * @file ContextBadge.tsx
 * @description Бэйдж одного AccountContext (phase08.5 shadcn).
 */

import { ShieldUser, Store } from "lucide-react";

import { Badge } from "./badge";

export interface ContextBadgeData {
  id: string;
  contextType: "PLATFORM" | "SHOP";
  shop: { id?: string; slug?: string; displayName: string } | null;
  role: { displayName: string };
}

interface ContextBadgeProps {
  ctx: ContextBadgeData;
  showScope?: boolean;
  size?: "small" | "medium";
}

function ContextBadgeRoot({ ctx, showScope = false }: ContextBadgeProps) {
  const isPlatform = ctx.contextType === "PLATFORM";
  const scopeName = isPlatform ? "Платформа" : ctx.shop?.displayName ?? "—";
  const label = showScope
    ? `${ctx.role.displayName} · ${scopeName}`
    : ctx.role.displayName;
  const Icon = isPlatform ? ShieldUser : Store;

  return (
    <Badge variant={isPlatform ? "primary" : "secondary"}>
      <Icon className="size-3" />
      {label}
    </Badge>
  );
}

function Empty({ label = "Нет контекстов" }: { label?: string }) {
  return <Badge variant="outline">{label}</Badge>;
}

export const ContextBadge = Object.assign(ContextBadgeRoot, { Empty });
